/**
 * The footer nav (menu_via_citrus_nav) renders from the same "custom-menu" navigation resource
 * live uses, but doesn't reproduce live's real link order (confirmed against viacitrus.com: The
 * Grove, Supplies, Contact, Trees, All Products, Care/FAQ, About Us) -- not a theme-code bug (see
 * CLAUDE.md: both themes do a plain unsorted loop over the same linklist), so the fix belongs
 * either in Shopify Admin or here. Reordering the rendered <li>s by href is the theme-only,
 * reversible option -- it doesn't touch live navigation data, and it's what the desktop wrap
 * breakpoint and the mobile 3-then-4 grid CSS (via-citrus-footer.liquid) both already assume.
 */
(function () {
  var ORDER = [
    '/blogs/the-grove',
    '/collections/supplies',
    '/pages/contact',
    '/collections/trees',
    '/collections/all-products',
    '/pages/faq',
    '/pages/about-us',
  ];

  function init() {
    var footer = document.querySelector('[id^="shopify-section-"][id$="__footer"]');
    var list = footer && footer.querySelector('.list-unstyled');
    if (!list || list.dataset.vcOrdered) return;
    list.dataset.vcOrdered = 'true';

    var items = Array.from(list.children);
    items.sort(function (a, b) {
      var aLink = a.querySelector('a');
      var bLink = b.querySelector('a');
      var aIndex = aLink ? ORDER.indexOf(aLink.getAttribute('href')) : -1;
      var bIndex = bLink ? ORDER.indexOf(bLink.getAttribute('href')) : -1;
      if (aIndex === -1) aIndex = ORDER.length;
      if (bIndex === -1) bIndex = ORDER.length;
      return aIndex - bIndex;
    });

    items.forEach(function (item) {
      list.appendChild(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
